<template>
  <section>
    <b-tabs
      content-class="pt-1 pb-2"
      :value="activeTabIndex"
      @input="onChangeTab"
    >
      <b-tab
        :title="$tk('ClientPortal.Gallery.Creatives')"
      >
        <GalleryCreatives v-if="visitedTabs.includes(0)" />
      </b-tab>
      <b-tab
        :title="$tk('ClientPortal.Gallery.Videos')"
      >
        <GalleryVideos v-if="visitedTabs.includes(1)" />
      </b-tab>
    </b-tabs>
  </section>
</template>

<script>
import GalleryCreatives from './GalleryCreatives.vue'
import GalleryVideos from './GalleryVideos.vue'

export default {
  components: {
    GalleryVideos,
    GalleryCreatives,
  },
  data() {
    return {
      visitedTabs: [],
      tabHashes: ['#creatives', '#videos'],
    }
  },
  computed: {
    activeTabIndex() {
      const route = this.$route.hash.toLowerCase()
      return this.tabHashes.findIndex(x => x === route) || 0
    },
  },
  mounted() {
    const route = this.$route.hash.toLowerCase()
    this.visitedTabs.push(this.tabHashes.findIndex(x => x === route) || 0)
  },
  methods: {
    onChangeTab(tab) {
      if (!this.visitedTabs.includes(tab)) {
        this.visitedTabs.push(tab)
      }

      const hash = this.tabHashes[tab]
      this.$router.replace({ hash })
    },
  },
}
</script>
